import { create } from "zustand";

interface PermissionStore {
  dialogOpen: boolean;
  editingCode: string | null;

  openDialogForAdd: () => void;
  openDialogForEdit: (code: string) => void;
  closeDialog: () => void;
}

export const usePermissionStore = create<PermissionStore>((set) => ({
  dialogOpen: false,
  editingCode: null,

  openDialogForAdd: () => set({ dialogOpen: true, editingCode: null }),
  openDialogForEdit: (code) => set({ dialogOpen: true, editingCode: code }),
  closeDialog: () => set({ dialogOpen: false, editingCode: null }),
}));
